export default __webpack_public_path__ + "static/media/spo2-gray.cad0bfb3.svg";